import DOMPurify from "dompurify";
import diff from "../../DiffView/htmldiff/htmldiff";
import { CompareHtml } from "./toCompareHtml";

export const DIFF_CLASS = "dcdiff";

export const renderCompareDiff = ({ older, viewed }: CompareHtml): string =>
  DOMPurify.sanitize(diff(older, viewed, true, DIFF_CLASS));
